const AccidentTrend = {
    chart: {
        miWidth: 260,
        maxWidth: 480,
        height: 110,
        marginBottom: 25,
        backgroundColor: '#F2F3F3',
        borderRadius: 8
    },
    title: {
        text: "Accident trend",
        align: 'left',
        style: {
            fontFamily: 'Stolzl-Medium',
            fontStyle: 'normal',
            color: '#282B2D',
            textDecoration: 'none',
            fontSize: '14px',
            fontWeight: '500',
            lineHeight: '18px',
            whiteSpace:'nowrap'
        }
    },
    exporting: {
        enabled: false
    },
    legend: {
        enabled: false
    },
    plotOptions: {
        line: {
            color: 'rgba(255, 212, 142, 1)',
            dataLabels: {
                enabled: true,
                style: {
                    fontFamily: 'Roboto',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    fontSize: '11px',
                    textOutline: 'none',
                    lineHeight: '16px',
                    textAlign: 'center',
                    color: '#3D3935'
                }

            },
            enableMouseTracking: false
        }
    },
    tooltip: {
        enabled: false
    },
    credits: {
        enabled: false
    },
    series: [{
        data: [{
            y: 9,
            name: "+9",
            color: "#FFB946"
        }, {y: 6, name: "-3", color: "#FFB946"}, {y: 2, name: "-3", color: "#FFB946"}, {
            y: -3,
            name: "-3",
            color: "#FFB946"
        }, {y: 9, name: "+9", color: "#FFB946"}],
        // animation: false,
        dataLabels: {
            formatter: function () {
                return this.point.name + '%'
            }
        }

    }],
    xAxis: {
        categories: [2016,2017, 2018, 2019, 2020, 2021, 2022, 2023],
        lineWidth: 0,
        labels: {
            style: {
                fontFamily: 'Roboto',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: '11px',
                lineHeight: '16px',
                color: '#777572',
            }
        },
    },
    yAxis: {
        tickAmount: 0,
        gridLineWidth: 0,
        title: {
            enabled: false
        },
        labels: {
            enabled: false,
        }
    }
}
export default AccidentTrend;
